import { type ConsolaInstance, createConsola } from "consola";

const globalForLogger = globalThis as typeof globalThis & {
	__repoLogger?: ConsolaInstance;
};

// One instance per process so reporters added at start-up (Sentry) apply
// everywhere, even when bundlers duplicate this module across entry points.
export const logger =
	globalForLogger.__repoLogger ??
	(globalForLogger.__repoLogger = createConsola({
		formatOptions: {
			date: false,
		},
	}));
